var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51493 17.134C6.9209 19.7655 3.24755 20.0089 3.24755 20.0089C4.8208 18.6835 5.63487 17.1862 6.04281 15.8324C3.17621 14.3067 1.33496 11.9624 1.33496 9.33089C1.33496 4.73097 6.94377 1.00183 13.8615 1.00183V1C20.7792 1 26.388 4.72914 26.388 9.32815C26.388 10.8465 25.7669 12.267 24.6986 13.4927",
    stroke: "#B7C1C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5947 6.80664C20.3164 6.8067 22.7672 7.53238 24.5303 8.69141C26.2953 9.85176 27.3456 11.4258 27.3457 13.1289C27.3457 15.0778 25.9628 16.8596 23.7207 18.0391L23.5381 18.1357L23.5986 18.334C23.8802 19.2552 24.3932 20.2558 25.3008 21.1875C25.0484 21.1361 24.7473 21.0654 24.417 20.9629C23.4493 20.6626 22.24 20.1113 21.2432 19.1104L21.1436 19.0107L21.0068 19.0439C19.9427 19.3047 18.7973 19.4531 17.5967 19.4531C14.877 19.4531 12.4257 18.7274 10.6621 17.5684C8.89673 16.408 7.84584 14.8338 7.8457 13.1309C7.8457 11.4276 8.89664 9.85222 10.6621 8.69141C12.4255 7.53199 14.8763 6.80664 17.5947 6.80664Z",
    fill: "#1CEC80",
    stroke: "#B7C1C3",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.3a01157eda4abec3c12ea8f944565511.svg";
export { ForwardRef as ReactComponent };